import { SourceMapSuggestion } from '../types'

export interface RankedCandidate {
  sourceId: string
  confidence: number
}

export interface SiblingCandidates {
  customer: RankedCandidate[]
  supplier: RankedCandidate[]
  customerAlreadyMappedIds?: string[]
  supplierAlreadyMappedIds?: string[]
}

export const alreadyMappedIdsFor = (
  role: 'customer' | 'supplier',
  candidates: SiblingCandidates | undefined
): string[] => (role === 'customer' ? candidates?.customerAlreadyMappedIds : candidates?.supplierAlreadyMappedIds) ?? []

export const groupSuggestionsBySibling = (
  suggestions: SourceMapSuggestion[],
  siblingIds: string[]
): Map<string, SiblingCandidates> => {
  const siblingSet = new Set(siblingIds)
  const map = new Map<string, SiblingCandidates>()

  suggestions.forEach(suggestion => {
    const localId = suggestion.identifiers.find(identifier => identifier.identifierType === 'local')?.value
    const sourceId = suggestion.identifiers.find(identifier => identifier.identifierType === 'source')?.value
    if (!localId || !sourceId || !siblingSet.has(localId)) return

    const entry = map.get(localId) ?? { customer: [], supplier: [] }
    const candidate: RankedCandidate = {
      sourceId,
      confidence: suggestion.confidence
    }
    if (suggestion.sourceEntity === 'Customer') entry.customer.push(candidate)
    else if (suggestion.sourceEntity === 'Supplier') entry.supplier.push(candidate)
    map.set(localId, entry)
  })

  map.forEach(entry => {
    entry.customer.sort((a, b) => b.confidence - a.confidence)
    entry.supplier.sort((a, b) => b.confidence - a.confidence)
  })

  return map
}
